// extracted by mini-css-extract-plugin
export default {"Header":"Header-module--Header--62c8c","Header__positionAbsolute":"Header-module--Header__positionAbsolute--1a6af"};